import axios from "axios";

export const LAB_TIMEOUT = 120000;
const inFlight = new Map();

// Only reads may be retried automatically. A lost write response is ambiguous.
export function readLaboratory(url) {
  if (inFlight.has(url)) return inFlight.get(url);
  const request = (async () => {
    for (let attempt = 0; ; attempt += 1) {
      try {
        return await axios.get(url, { timeout: LAB_TIMEOUT });
      } catch (error) {
        const transient = ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code) ||
          [408, 429, 502, 503, 504].includes(error.response?.status);
        if (!transient || attempt >= 2 || navigator.onLine === false) throw error;
        await new Promise((resolve) => setTimeout(resolve, 1000 * (attempt + 1)));
      }
    }
  })();
  inFlight.set(url, request);
  request.finally(() => inFlight.delete(url)).catch(() => {});
  return request;
}
